import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';

export function RecordResultsSkeleton() {
    return (
        <div>
            <Skeleton variant="rect" height={150} style={{marginBottom: '1rem'}}/>
            <Skeleton variant="rect" height={200} style={{marginBottom: '1rem'}}/>
            <Skeleton variant="rect" height={100} style={{marginBottom: '1rem'}}/>
        </div>
    );
}

export function SelectTestSkeleton() {
    return (
        <div>
            <Skeleton variant="rect" height={25} style={{marginBottom: '0.5rem'}}/>
            <Skeleton variant="rect" height={25} style={{marginBottom: '0.5rem'}}/>
        </div>
    );
}

export function TestDetailsSkeleton() {
    return (
        <Skeleton variant="rect" height={120}/>
    );
}
